module.exports = __webpack_public_path__ + "static/media/pizzaSalamiPimenton.1592cffb.jpeg";